//final latest
import React, { useEffect, useState } from "react";
import { useContext } from "react";
import TherapyRoomCard from "./TherapyRoomCard";
import Navbar from "../Navbar";
import Footer from "../Footer";
import { AuthContext } from "../../context/AuthContext";
import beach from "../../assets/images/beach.png";
import forest from "../../assets/images/forest.png";
import campsite from "../../assets/images/campsite.png";
import park from "../../assets/images/park.png";
import { useNavigate } from "react-router-dom";
import Env from '../../runtimeEnv';
import axios from "axios";

function ClientTherapyRooms() {
  const navigate = useNavigate();
  const [enabledRoom, setEnabledRoom] = useState([]);
  // const [loading, setLoading] = useState(true);
  const [roomsOnlineStatus, setRoomsOnlineStatus] = useState({});
  const [sessionStartTimes, setSessionStartTimes] = useState({});
  const [selectedSpace, setSelectedSpace] = useState(null);
  const [meetingExists, setMeetingExists] = useState(false);
  const {
    currentNickname,
    setCurrentNickname,
    PlutonicuserID,
    loading,
    setLoading,
    
  } = useContext(AuthContext);

  useEffect(() => {
    const initializeState = async () => {
      const savedUserID =
        PlutonicuserID || localStorage.getItem("PlutonicuserID");
      const savedNickname =
        currentNickname || localStorage.getItem("currentNickname");

      if (savedNickname) {
        setCurrentNickname(savedNickname);
      }

      if (savedUserID) {
        try {
          const response = await axios.get(
            `${Env.REACT_APP_PYTHON_API_URL}/api/GetMeetings/${savedUserID}`
          );

          if (response.data.length > 0) {
            const nowUTC = new Date();
            const gracePeriodBeforeMs = 15 * 60 * 1000;
            const gracePeriodAfterMs = 75 * 60 * 1000;
            const backToBackBufferMs = 20 * 60 * 1000;

            let hasEligibleMeeting = false;
            let latestUpcomingSession = null;

            const roomSessionsMap = response.data.reduce((acc, room) => {
              const roomId = room.meetingID.split("-")[0];
              const sessionTimeUTC = new Date(room.sessionTime);

              const formattedTimeEST =
                sessionTimeUTC.toLocaleString("en-US", {
                  timeZone: "America/New_York",
                  month: "2-digit",
                  day: "2-digit",
                  year: "numeric",
                  hour: "2-digit",
                  minute: "2-digit",
                  hour12: true,
                }) + " EST";

              if (!acc[roomId]) acc[roomId] = [];

              acc[roomId].push({
                meetingID: room.meetingID,
                sessionStartTimeEST: formattedTimeEST,
                sessionStartTimeUTC: sessionTimeUTC.toISOString(),
                rawStartTime: sessionTimeUTC,
                online: room.online.some((s) => s === true),
                isAvailable: false,
                isUpcoming: false,
              });

              return acc;
            }, {});

            Object.keys(roomSessionsMap).forEach((roomId) => {
              const sessions = roomSessionsMap[roomId];
              sessions.sort(
                (a, b) =>
                  new Date(a.sessionStartTimeUTC) -
                  new Date(b.sessionStartTimeUTC)
              );

              for (let i = 0; i < sessions.length; i++) {
                const current = sessions[i];
                const next = sessions[i + 1];

                const currentStart = new Date(current.sessionStartTimeUTC);
                const timeUntilCurrent = currentStart - nowUTC;
                const timeSinceCurrent = nowUTC - currentStart;

                const isInGraceWindow =
                  (timeUntilCurrent <= gracePeriodBeforeMs &&
                    timeUntilCurrent >= 0) ||
                  (timeSinceCurrent >= 0 &&
                    timeSinceCurrent <= gracePeriodAfterMs);

                const isUpcoming =
                  timeUntilCurrent > 0 &&
                  timeUntilCurrent <= gracePeriodBeforeMs;
                let isSuppressed = false;

                if (next) {
                  const nextStart = new Date(next.sessionStartTimeUTC);
                  const timeUntilNext = nextStart - nowUTC;
                  const allowSuppression =
                    timeUntilNext <= backToBackBufferMs &&
                    timeUntilNext >= -15 * 60 * 1000;

                  if (allowSuppression) {
                    isSuppressed = true;
                    next.isUpcoming = true;
                  }
                }

                current.isAvailable = isInGraceWindow;
                current.isUpcoming = isUpcoming;
                current.isPrimary =
                  (isInGraceWindow || isUpcoming) && !isSuppressed;

                // if (current.isAvailable || current.isUpcoming) {
                //   hasEligibleMeeting = true;
                // }
                hasEligibleMeeting = true; // Mark as true if *any* session exists, not just active/upcoming

                if (
                  current.isPrimary &&
                  (!latestUpcomingSession ||
                    currentStart >
                      new Date(latestUpcomingSession.sessionStartTimeUTC))
                ) {
                  latestUpcomingSession = current;
                }
              }
            });

            const sessionStartTimesMap = Object.entries(roomSessionsMap).reduce(
              (acc, [roomId, sessions]) => {
                const nextSession = sessions.find(
                  (session) => session.isAvailable || session.isUpcoming
                );
                if (nextSession) acc[roomId] = nextSession.sessionStartTimeEST;
                return acc;
              },
              {}
            );

            const onlineStatusMap = Object.entries(roomSessionsMap).reduce(
              (acc, [roomId, sessions]) => {
                acc[roomId] = sessions.some((session) => session.online);
                return acc;
              },
              {}
            );

            setRoomsOnlineStatus(onlineStatusMap);
            setEnabledRoom(roomSessionsMap);
            setSessionStartTimes(sessionStartTimesMap);
            setMeetingExists(hasEligibleMeeting);
          } else {
            setMeetingExists(false);
          }
        } catch (error) {
          // console.error("[ClientTherapyRooms] Failed to fetch meeting details:", error);
          setMeetingExists(false);
        }
      }

      setLoading(false);
    };

    initializeState();
  }, [PlutonicuserID]);

  useEffect(() => {
    if (PlutonicuserID) {
      axios
        .get(
          `${Env.REACT_APP_PYTHON_API_URL}/api/get-selected-space/${PlutonicuserID}`
        )
        .then((res) => {
          const space = res.data.selectedSpace;
          if (space) {
            setSelectedSpace(space);
          } else {
            console.log("No space selected previously.");
          }
        })
        .catch((err) => console.error("Error fetching selected space:", err));
    }
  }, [PlutonicuserID]);

  // ✅ Step 3: Handle space selection (only if meeting exists)
  const handleSpaceSelection = (spaceId) => {
    // console.log("Selected Space ID:", spaceId);
    // if (!meetingExists) {
    //     alert("No active meeting found. Cannot select a space.");
    //     return;
    // }
    if (!meetingExists) {
      // Find latest past session across all rooms
      const allSessions = Object.values(enabledRoom).flat();
      const now = new Date();
      const pastSessions = allSessions
        .filter((session) => new Date(session.rawStartTime) < now)
        .sort((a, b) => new Date(b.rawStartTime) - new Date(a.rawStartTime));

      const latestPastSession = pastSessions[0];
      console.log(latestPastSession);

      if (!latestPastSession) {
        // alert("No session history found to save your selection.");
        return;
      }

      axios
        .post(`${Env.REACT_APP_PYTHON_API_URL}/api/select-space`, {
          PlutonicuserID: PlutonicuserID,
          selectedSpace: spaceId,
          meetingID: latestPastSession.meetingID, // Include the past meeting ID
        })
        .then(() => {
          setSelectedSpace(spaceId);
          // console.log("Space selection saved to latest past session.");
        })
        .catch((err) => console.error("Error updating space selection:", err));

      return;
    }

    if (selectedSpace === spaceId) {
      // console.log("Space is already selected. No API call needed.");
      return; // ✅ Avoid unnecessary API request
    }

    setSelectedSpace(spaceId);
    axios
      .post(`${Env.REACT_APP_PYTHON_API_URL}/api/select-space`, {
        PlutonicuserID: PlutonicuserID,
        selectedSpace: spaceId,
      })
      .then(() => console.log("Space selection updated"))
      .catch((err) => console.error("Error updating space selection:", err));
  };

  const rooms = [
    {
      id: "beach",
      title: "Plutonic Therapy Beach Office",
      description:
        "Consider having a session with your licensed mental health professional inside the office or in the cabana. Take in the sounds of the ocean waves and the sunset as you reduce stress.",
      accessibility: "PC Web Browser | Chrome, Edge",
      style: "Modern Design",
      usage: "Family Counseling",
      image: beach,
      // available: enabledRoom["beach"]?.some((session) => session.isAvailable) || false,
      selectable: enabledRoom["beach"]?.length > 0 ?? false, // Selectable if a meeting exists
      available:
        enabledRoom["beach"]?.some((session) => session.isAvailable) ?? false, // Enterable only if within grace period
      isComingSoon: false,
      online: roomsOnlineStatus["beach"] || false,
      sessionStartTimeEST: sessionStartTimes["beach"] || "",
    },
    {
      id: "mountain",
      title: "Plutonic Therapy Forest Office",
      description:
        "Consider having a session with your licensed mental health professional next to the fireplace. Take in the sounds and sights of the forest.",
      accessibility: "PC Web Browser | Chrome, Edge",
      style: "Modern Design",
      usage: "Family Counseling",
      image: forest,
      // available: enabledRoom["mountain"]?.some((session) => session.isAvailable) || false,
      // selectable: false, // Cannot select "coming soon" rooms
      available:
        enabledRoom["mountain"]?.some((session) => session.isAvailable) ||
        false,
      selectable: enabledRoom["mountain"]?.length > 0 ?? false, // Selectable if a meeting exists
      isComingSoon: false,
      online: roomsOnlineStatus["mountain"] || false,
      sessionStartTimeEST: sessionStartTimes["mountain"] || "",
    },

    {
      id: "park",
      title: "Plutonic Therapy Quiet Park",
      description:
        "Consider having a session with your licensed mental health professional while taking a walk around the park or while sitting on a park bench. This quiet park is a perfect safe space to talk.",
      accessibility: "PC Web Browser | Chrome, Edge",
      style: "Green Space",
      usage: "Family Counseling",
      image: park,
      available:
        enabledRoom["park"]?.some((session) => session.isAvailable) || false,
      selectable: enabledRoom["park"]?.length > 0 ?? false, // Selectable if a meeting exists
      // enterable: enabledRoom["park"]?.some((session) => session.isAvailable) ?? false, // Enterable only if within grace period
      isComingSoon: false,
      online: roomsOnlineStatus["park"] || false,
      sessionStartTimeEST: sessionStartTimes["park"] || "",
    },
    {
      id: "campsite",
      title: "Plutonic Therapy Campfire",
      description:
        "Unpack your thoughts with your licensed mental health professional next to the campfire. Trees swaying and crickets chirping while enjoying the beautiful night sky. ",
      accessibility: "PC Web Browser | Chrome, Edge",
      style: "Green Space",
      usage: "Family Counseling",
      image: campsite,
      available:
        enabledRoom["campsite"]?.some((session) => session.isAvailable) ||
        false,
      selectable: enabledRoom["campsite"]?.length > 0 ?? false, // Selectable if a meeting exists
      // enterable: enabledRoom["park"]?.some((session) => session.isAvailable) ?? false, // Enterable only if within grace period
      isComingSoon: false,
      online: roomsOnlineStatus["campsite"] || false,
      sessionStartTimeEST: sessionStartTimes["campsite"] || "",
    },
  ];

  const handleEnterClick = (roomType, meetingID = null) => {
    const userId = PlutonicuserID || localStorage.getItem("PlutonicuserID");

    // Handle test rooms
    if (
      roomType === "test-beach" ||
      roomType === "test-park" ||
      roomType === "test-forest" ||
      roomType === "test-campsite"
    ) {
      const testMeetingID = `${roomType}-test-meeting-id`;
      sessionStorage.setItem("meetingID", testMeetingID);
      sessionStorage.setItem("userId", userId);

      const realRoomType =
        roomType === "test-beach"
          ? "beach"
          : roomType === "test-park"
          ? "park"
          : roomType === "test-forest"
          ? "forest"
          : roomType === "test-campsite"
          ? "campsite"
          : "";

      // console.log(`[TestPage] Navigating to Unity build for ${realRoomType} room`);
      navigate(`/unity-room/${realRoomType}`);
      return;
    }

    if (meetingID) {
      // Directly enter the selected session
      sessionStorage.setItem("meetingID", meetingID);
      sessionStorage.setItem("userId", userId);
      navigate(`/unity-room/${roomType}`);
      return;
    }

    // Otherwise fallback to finding an available session
    const roomSessions = enabledRoom[roomType];
    if (!roomSessions || roomSessions.length === 0) {
      // alert("Room is not enabled. Please wait or check your eligibility.");
      return;
    }

    const session = roomSessions.find((s) => s.isAvailable);
    if (!session) {
      // alert("No active session is available at this time.");
      return;
    }

    sessionStorage.setItem("meetingID", session.meetingID);
    sessionStorage.setItem("userId", userId);
    navigate(`/unity-room/${roomType}`);
  };

  if (loading) {
    return (
      <div
        style={{
          height: "100vh",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <p>Loading...</p>
      </div>
    );
  }

  return (
    <div>
      <Navbar
      // setCurrentNickname={(nickname) => {
      //   setCurrentNickname(nickname);
      //   localStorage.setItem("currentNickname", nickname);
      // }}
      // currentNickname={currentNickname}
      // handleLogout={handleLogout}
      // setCurrentFormType={setCurrentFormType}
      // showButtons={true}
      // PlutonicuserID={
      //   PlutonicuserID || localStorage.getItem("PlutonicuserID")
      // }
      />
      <div
        className="flex flex-col items-center min-h-screen pt-24 pb-16 px-12 mx-auto"
        style={{
          background: "linear-gradient(to bottom, #CBCECE, #77D8EE, #CBCECE)",
        }}
      >
        <h2 className="text-3xl font-bold mb-8 self-start pl-4 mt-8">
          Your Virtual Spaces
        </h2>
        <h2 className="text-xl font-bold mb-4 self-start pl-4 ">
          Select Your Preferred Session Space
        </h2>

        <div className="grid gap-8 grid-cols-1 md:grid-cols-2 lg:grid-cols-3 w-full">
          {rooms.map((room) => (
            <TherapyRoomCard
              key={room.id}
              room={room}
              isSelected={selectedSpace === room.id}
              onSelect={() => handleSpaceSelection(room.id)}
              onEnterClick={(meetingID) => handleEnterClick(room.id, meetingID)}
              sessions={enabledRoom[room.id] || []}
            />
          ))}
        </div>
      </div>

      <Footer />
    </div>
  );
}

export default ClientTherapyRooms;